import React, { useState } from 'react';
import './AdProduct.css';
import { useStateValue } from './StateProvider';
import CurrencyFormat from 'react-currency-format';
import { Link, useHistory } from 'react-router-dom';
import axios from 'axios';
import { useEffect } from 'react';

function AdProduct({id, title, price, img, searching_words, sold}) {
    const [ { basket, admnavagationoption }, dispatch] = useStateValue();
    const history = useHistory();
    const [active, setActive] = useState(true);
    const [respo, setRespo] = useState('');

    const hedit = () => {
        dispatch({
            type: "SET_PRODUCTDETAILS",
            item:{
                id: id,
                title: title,
                price: price,
                img: img,
                searching_words: searching_words,
                qnt: 1
            },
        });

        history.push('/admin-product-edit');
    }

    const hdelete = () => {
        setActive(!active);
    }

    const hno = () => {
        setActive(!active);
    }

    const hyes = () => {
        axios
            .get("https://toycityzimbabwe.com/backend/deleteProduct.php", {params: { id }})
            .then(data => {
                if(data.data === 'Record deleted successfully'){
                    specs();
                }else{
                    setRespo('Error')
                }
            })
            .catch(error => console.log(error));
    }

    const specs = () =>{
        axios
            .get("https://toycityzimbabwe.com/backend/deleteProductSpecs.php", {params: { title }})
            .then(data => {
                if(data.data === 'Record deleted successfully'){
                    setRespo('Deleted successfully');
                }else{
                    setRespo('Error');
                }
            })
            .catch(error => console.log(error));

        dispatch({
            type: 'SET_ADMNO',
            admnavagationoption: 'two'
        })

        setActive(!active);
            
        history.push('/Admin14F-efghS=workApp/filesManagement-Wdf17/Admin');
    }

    const onDetails =(id, title, price, img) =>{

        dispatch({
            type: "SET_PRODUCTDETAILS",
            item:{
                id: id,
                title: title,
                price: price,
                img: img,
                searching_words: searching_words,
                qnt: 1
            },
        });

    }

    const hsold = () =>{
        
        console.log(sold)

        axios
          .get('https://toycityzimbabwe.com/backend/updateSoldProduct.php', {params: {id, sold}})
          .then(res => {
            if(res.data === 'Update Sucessfully')
            {
                console.log(res.data)
            }else{
                console.log(res.data)
            }            
          })
          .catch( error => {
              console.log(error)
          });

        window.location.reload(true)

    }

    return (active
        ?<div className="product">
            <Link to='/admin-product-details'><div className="product__img" onClick={ () => onDetails(id, title, price, img, searching_words)}><img src={img} alt="" /></div></Link>
            <h4>{title}</h4>
            <div>
                <CurrencyFormat
                    renderText={(value) => (
                        <>
                            <h3>{value}</h3>
                        </>
                    )}
                    decimalScale={2}
                    value={price}
                    displayType={"text"}
                    thousandSeparator={true}
                    prefix={"$"}
                />
            </div>
            <div className="product__btn">
                <button onClick={hedit}>Edit</button>

                <button onClick={hdelete}>Delete</button>
            </div>
            <div className={(sold == 0) ? "product__btn product__btn__notsold" : "product__btn product__btn__sold" }>
                <button onClick={hsold}>Sold</button>
            </div>
        </div>
        :
        <div className="product">
            <div className="product__img" ><img src={img} alt="" /></div>
            <h4 className='product__delete'>{'Delete?'}</h4>
            <div className="product__btn">
                <button onClick={hyes}>Yes</button>

                <button onClick={hno}>No</button>
            </div>
        </div>
    )
}

export default AdProduct;
